import { render } from "./LabelPrintView.vue?vue&type=template&id=ab8c85e2"
import script from "./LabelPrintView.vue?vue&type=script&lang=js"
export * from "./LabelPrintView.vue?vue&type=script&lang=js"

import "./LabelPrintView.vue?vue&type=style&index=0&id=ab8c85e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__